import Highcharts from "highcharts";

const light = (Highcharts.theme = {
  title: {
    align: "center",
    style: {
      color: "black",
    },
  },
  yAxis: {
    gridLineWidth: 1,
    gridLineColor: "#BDBDBD",
    tickmarkPlacement: "on",
    labels: {
      style: {
        color: "black",
      },
    },
    lineColor: "black",
  },
  plotOptions: {
    column: {
      stacking: "normal",
      grouping: false,
      borderColor: "black",
    },
  },
  legend: {
    align: "center",
    verticalAlign: "bottom",
    itemStyle: {
      color: "#101010", // Set the desired font color for the legend text
    },
  },
  xAxis: {
    gridLineColor: "#BDBDBD",
    lineColor: "black",
    categories: [],
    labels: {
      style: {
        color: "black",
      },
    },
  },
});
const dark = (Highcharts.theme = {
  title: {
    align: "center",
    style: {
      color: "grey",
    },
  },
  yAxis: {
    gridLineWidth: 1,
    gridLineColor: "#262626",
    title: {
      text: "",
    },

    tickmarkPlacement: "on",
    labels: {
      style: {
        color: "#FFFFFF",
      },
    },
    lineColor: "#FFFFFF",
  },
  xAxis: {
    gridLineColor: "#262626",
    lineColor: "#FFFFFF",
    categories: [],
    labels: {
      style: {
        color: "#FFFFFF",
      },
    },
  },
  plotOptions: {
    column: {
      stacking: "normal",
      grouping: false,
      borderColor: "black",
    },
  },
  legend: {
    align: "center",
    verticalAlign: "bottom",
    itemStyle: {
      color: "#FFFFFF", // Set the desired font color for the legend text
    },
  },
});
export const getTheme = (
  titleval: any,
  isLightTheme: boolean,
  xaxisValues: any
) => {
  if (isLightTheme) {
    return {
      ...light,
      title: { ...light.title, text: titleval },
      xAxis: { ...light.xAxis, categories: xaxisValues },
    };
  } else {
    return {
      ...dark,
      title: { ...dark.title, text: titleval },
      xAxis: { ...dark.xAxis, categories: xaxisValues },
    };
  }
};
